import React from 'react';
import './JobConfirmation.css';

const JobConfirmation = ({ jobTitle, jobDescription, company, location, job, schedule, channels, requirements, note }) => {

    // Use this function wherever you process or render job descriptions
// function replaceMontserratWithNotoSans(jobDescription) {
//   return jobDescription.replace(
//     /font-family:\s*['"]Montserrat['"],\s*sans-serif;/gi,
//     "font-family: 'Noto Sans', sans-serif;"
//   );
// }
// const updatedDescription = replaceMontserratWithNotoSans(jobDescription);
    return (


        <div className="text-align-initial px-50px job-posting-container mb-auto">
             <div className=" job-description jd-fs-20">
            <p className="mb-30">Get ready…I’m about to call you!</p>

            <p className='mb-30'>While you wait, let’s get to know each other.</p>

            <p className='mb-30'>
              Hi – I’m Anna AI, but you can just call me Anna. I’m your digital
              recruiter, and I’m really glad you’re here.
            </p>

            <p className='mb-30'>Here’s a little about me:</p>
            <ul>
              <li>I'm multilingual and can be configured in 17 languages, but for this demo, I will only speak in English</li>
              <li>
                I get to talk with candidates around the world 24 hours a day, 7
                days a week
              </li>
              <li>
                Anything you tell me is secure and protected by the highest
                levels of HIPAA, GDPR, and privacy and compliance standards
              </li>
              <li>Enough about me. I can’t wait to get to know you!</li>
            </ul>
          </div>
        </div>

        
    //   <div className="text-align-initial px-50px job-posting-container">
    //     <h3 className="heading-normal">
    //       <span>Thank you for choosing Anna AI, our digital recruiter. 🙌</span>
    //       <br />
    //       <p className="no-margin-top">
    //         Get ready! Anna will call you shortly to begin your interview. Just
    //         answer the phone, and she’ll guide you through a quick, natural
    //         conversation based on a job opportunity at TP.
    //       </p>
    //       {/* <br /> */}
    //       <span className="no-margin-top">
    //         In the meantime, feel free to explore about the role and the job
    //         description below.
    //       </span>
    //     </h3>
    //     <div className="bg-with-style pt-2">
    //       <div className="no-margin-top mt-20 row">
    //         <h2 className="jd-custom-heading SancoaleRegular fs-28">
    //           {jobTitle}
    //         </h2>
    //       </div>
    //       {location && (
    //         <div className="no-margin-top m-10">
    //           <strong>Location:</strong>
    //           <span> {location}</span>
    //         </div>
    //       )}

    //       {schedule && (
    //         <div className="no-margin-top m-10">
    //           <strong>Schedule: </strong>
    //           <span>{schedule}</span>
    //         </div>
    //       )}

    //       {channels && (
    //         <div className="no-margin-top m-10">
    //           <strong>Channels: </strong>
    //           <span>{channels}</span>
    //         </div>
    //       )}

    //       {requirements && (
    //         <div className="no-margin-top m-10">
    //           <strong>Requirements: </strong>
    //           <span>{requirements}</span>
    //         </div>
    //       )}

    //       {company && (
    //         <div className="no-margin-top m-10">
    //           <strong>Company: </strong>
    //           <span>{company}</span>
    //         </div>
    //       )}

    //       {job.Salary && (
    //         <div className="no-margin-top m-10">
    //           <strong>Salary:</strong>
    //           <span> The pay we're offering is {job.Salary}/hr</span>
    //         </div>
    //       )}

    //       {note && (
    //         <div className="no-margin-top m-10">
    //           <strong>Note: </strong>
    //           <span> {note}</span>
    //         </div>
    //       )}
    //     </div>

    //     <div className="job-details">
    //       <div className="job-description no-margin-top font-weight-normal">
    //                 <div dangerouslySetInnerHTML={{ __html: jobDescription }} />
    //             </div>
          
    //     </div>
    //   </div>
    );
};

export default JobConfirmation;